import script from "./AppCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCard.vue?vue&type=script&setup=true&lang=js"

import "./AppCard.vue?vue&type=style&index=0&id=27df1c08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27df1c08"]])

export default __exports__